import { createSlice } from '@reduxjs/toolkit'
import { MQTTState } from './types'

export const initialMqttState: MQTTState = {}

export const mqttSlice = createSlice({
  name: 'mqtt',
  initialState: initialMqttState,
  reducers: {}
})

export const reducer = mqttSlice.reducer
